// Vendor Libs
import {cloneDeep} from 'lodash';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
};

const actions = {
    FETCH_MARKER_FINGERPRINT: () => ({
        ...getInitialState(),
        fetching: true,
    }),

    FETCH_MARKER_FINGERPRINT_FULFILLED: (state, {data}) => ({
        ...state,
        error: null,
        fetched: true,
        fetching: false,
        data,
    }),

    FETCH_MARKER_FINGERPRINT_REJECTED: (state, {error}) => ({
        ...state,
        fetched: true,
        fetching: false,
        error,
    }),

    RESET_MARKER_FINGERPRINT: () => getInitialState(),
};

function getInitialState() {
    return cloneDeep(initialState);
}

const reducer = (state = getInitialState(), action) =>
    actions[action.type] ? actions[action.type](state, action) : state;

export default reducer;
